import React, { useState } from 'react';
import AnimatedPage from '../../components/AnimatedPage';
import { useNavigate } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import VCB_DigiBank_Icon from '../../assets/images/icon_vcb digibank.png';
import Global_Pay_Icon from '../../assets/images/icon_global pay.png';
import Chu_Ky_So_Icon from '../../assets/images/icon_chu ky so.png';
import VCb_Tablet_Icon from '../../assets/images/icon_vcb tablet.png';
import QR_Pay_Icon from '../../assets/images/icon_QR thanh toan.png';
import Lua_Chon_Icon from '../../assets/images/Lua_Chon_Icon.png';
import Frame_Cong_Trinh from '../../assets/images/Frame_Cong_Trinh.png';
import Frame_Dau_An from '../../assets/images/Frame_Dau_An.png';
import Frame_Hoat_Dong from '../../assets/images/Frame_Hoat_Dong.png';
import Frame_Ket_Noi from '../../assets/images/Frame_Ket_Noi.png';
import Frame_Lua_Chon from '../../assets/images/Frame_Lua_Chon.png';
import Framm_1_Ty from '../../assets/images/Framm_1_Ty.png';
import Frame_Home from '../../assets/images/Frame_Home.png';
const Home = () => {
  const navigate = useNavigate();
  const [clickedButton, setClickedButton] = useState(null);

  const onClickButton = target => {
    setClickedButton(target);
    setTimeout(() => {
      setClickedButton(null);
      switch (target) {
        case 'dau_an':
          navigate('/page1/digisign');
          break;
        case 'cong_trinh':
          navigate('/page1/globalpay');
          break;
        case 'hoat_dong':
          navigate('/page1/biometric');
          break;
        case 'ket_noi':
          navigate('/page1/qrpay');
          break;
        case 'buoc_xanh':
          navigate('/page1/digibank');
          break;
        case 'lua_chon':
          navigate('/other');
          break;
        default:
          break;
      }
    }, 300);
  };

  return (
    <AnimatedPage animationType="fade">
      <Page1Container>
        <Text top={525}
          left={1500}>CHỮ KÝ SỐ</Text>
        <Frame src={Frame_Dau_An} top={238}
          left={1500} >
          <ButtonCircle1
            isClicked={clickedButton === 'dau_an'}
          >
            <div
              onClick={() => onClickButton('dau_an')}
              style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                top: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 3,
              }}
            >
              <Icon src={Chu_Ky_So_Icon} alt="" />
            </div>
          </ButtonCircle1>
        </Frame>
        <Text top={525}
          left={2230}>GLOBAL PAY
        </Text>
        <Frame src={Frame_Cong_Trinh} top={238}
          left={2244}>
          <ButtonCircle1
            isClicked={clickedButton === 'cong_trinh'}
          >
            <div
              onClick={() => onClickButton('cong_trinh')}
              style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                top: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 3,
              }}
            >
              <Icon src={Global_Pay_Icon} alt="" />
            </div>
          </ButtonCircle1>
        </Frame>
        <Text top={980}
          left={1075}>VCB TABLET
          <br />VĂN PHÒNG SỐ
          <br />THÔNG MINH
        </Text>
        <Frame src={Frame_Hoat_Dong} top={695}
          left={1130}>
          <ButtonCircle1

            isClicked={clickedButton === 'hoat_dong'}
          >
            <div
              onClick={() => onClickButton('hoat_dong')}
              style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                top: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 3,
              }}
            >
              <Icon src={VCb_Tablet_Icon} alt="" />
            </div>
          </ButtonCircle1>
        </Frame>
        <Text top={985}
          left={2575}>QR THANH TOÁN
          <br />XUYÊN BIÊN GIỚI
        </Text>
        <Frame src={Frame_Ket_Noi} top={695}
          left={2645}>
          <ButtonCircle1

            isClicked={clickedButton === 'ket_noi'}
          >
            <div
              onClick={() => onClickButton('ket_noi')}
              style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                top: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 3,
              }}
            >
              <Icon src={QR_Pay_Icon} alt="" />
            </div>
          </ButtonCircle1>
        </Frame>
        <Text top={1550}
          left={1220}>VCB DIGIBANK
        </Text>
        <Frame src={Framm_1_Ty} top={1260}
          left={1250}>
          <ButtonCircle1
            isClicked={clickedButton === 'buoc_xanh'}
          >
            <div
              onClick={() => onClickButton('buoc_xanh')}
              style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                top: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 2,
              }}
            >
              <Icon1 src={VCB_DigiBank_Icon} alt="" />
            </div>
          </ButtonCircle1>
        </Frame>
        <Text top={1545}
          left={2495}>LỰA CHỌN THÊM
        </Text>
        <Frame src={Frame_Lua_Chon} top={1260}
          left={2580}>
          <ButtonCircle1

            isClicked={clickedButton === 'lua_chon'}
          >
            <div
              onClick={() => onClickButton('lua_chon')}
              style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                top: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 3,
              }}
            >
              <Icon src={Lua_Chon_Icon} alt="" />
            </div>
          </ButtonCircle1>
        </Frame>
        <Frame src={Frame_Home} width={698} height={166} top={1550} left={1720}>
          <TextTitle>KẾT NỐI SỐ</TextTitle>
        </Frame>
      </Page1Container>
    </AnimatedPage>
  );
};
const Page1Container = styled.div`
z-index: 1;
width: 100%;
height: 100%;
`;
const rotate = keyframes`
	from { transform: translate(-50%, -50%) scale(1.4) rotate(0turn); }
	to { transform: translate(-50%, -50%) scale(1.4) rotate(1turn); }
`;

const clickAnimation = keyframes`
    0% { transform: translate(-50%, -50%) scale(1); }
    50% { transform: translate(-50%, -50%) scale(1.1); }
    100% { transform: translate(-50%, -50%) scale(1); }
`;
const Icon = styled.img`
    width: calc(175 / 4096 * 100vw);
    height:  auto;
    object-fit: contain;
`;
const Icon1 = styled.img`
    width: auto;
    height:  calc(175 / 4096 * 100vw);
    object-fit: contain;
    margin-left: calc(20 / 4096 * 100vw);
`;
const Frame = styled.div`
  position: absolute;
  z-index: 3;
  background-size: contain;
background-repeat: no-repeat;
background-position: center;
    background-image: url(${props => (props.src)});
      height: ${props => `calc( ${props.height || 320} / 4096 * 100vw)`};
    width: ${props => `calc( ${props.width || 320} / 4096 * 100vw)`};
     top: ${props => `calc( ${props.top || 968} / 2160 * 100vh)`};
    left: ${props => `calc( ${props.left || 1937} / 4096 * 100vw)`};
    display: flex;
    justify-content: center;
    align-items:center;

`;
const ButtonCircle1 = styled.div`
    --offset:5px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: ${props => `calc( ${props.height || 280} / 4096 * 100vw)`};
    width: ${props => `calc( ${props.width || 280} / 4096 * 100vw)`};
    max-width: 100%;
    border-radius: 10000px;
    background-color:#93f158;
    overflow: hidden;
    transition: transform 0.1s ease;
    animation: ${props => (props.isClicked ? clickAnimation : 'none')} 0.3s ease;
    color: white;

    &::before {
        content: '';
        background: conic-gradient(transparent 270deg, ${props => props.rgb || 'rgb(255 255 255)'}, transparent);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        aspect-ratio: 1 / 1;
        width: 100%;
        animation: ${rotate} 2s linear infinite;
        pointer-events: none;
    }

    &::after {
        content: '';
        background: inherit;
        border-radius: inherit;
        position: absolute;
        inset: var(--offset);
        height: calc(100% - 2 * var(--offset));
        width: calc(100% - 2 * var(--offset));
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        pointer-events: none;
    }
    &:hover {
        cursor: pointer;
    }
`;
const Text = styled.p`
font-size: ${props => `calc( ${props.size || 50} / 4096 * 100vw)`};
    font-weight: 800;
    color: #fff;
        position: absolute;
 top: ${props => `calc( ${props.top || 968} / 2160 * 100vh)`};
    left: ${props => `calc( ${props.left || 1937} / 4096 * 100vw)`};
    text-align: center;
`;
const TextTitle = styled.p`
font-size: ${props => `calc( ${props.size || 90} / 4096 * 100vw)`};
    font-weight: 1000;
    color: #fff;`;
export default Home;
